<script>
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";


export default {
  mixins: [apibtoast, apigeneric],
  props: ["satdosyaId", "Zarfbelgekontroltutanaktarih"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "99999",
        PageDataSize: "1",
      },
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
      satdosyaihaleilani: {},
      satdosyafirma: {},
      satdosyaihalekomisyonu: {},
      satdosyazarfacmakontrol: {},
      satonaybelgesi:{},
      okurumsabit:{},
      Alimturu:"",
    };
  },
  components: {
    Loader,

  },
  watch: {
    satdosyaId() {},
  },
  methods: {
    Get() {
      this.ActionsGet({
        Service: "okurumsabit",
        Page: this.Page
      }).then((res) => {
        this.okurumsabit = res.Data[0];
      });

      this.ActionsFilterGet({
        Service: "satonaybelgesi",
        Page: this.Page,
        Filter: "&Dosyaid=" + this.satdosyaId,
      }).then((res) => {
        this.satonaybelgesi = res.Data[0];
      });

      this.ActionsFilterGet({
        Service: "satdosyaihaleilani",
        Page: this.Page,
        Filter: "&Dosyaid=" + this.satdosyaId,
      }).then((res) => {
        this.satdosyaihaleilani = res.Data;
      });

      this.ActionsFilterGet({
        Service: "satdosyazarfacmakontrol",
        Page: this.Page,
        Filter: "&Dosyaid=" + this.satdosyaId,
      }).then((res) => {
        this.satdosyazarfacmakontrol = res.Data;
      });

      this.ActionsFilterGet({
        Service: "satdosyafirma",
        Page: this.Page,
        Filter: "&Dosyaid=" + this.satdosyaId + "&Firmaturu=3",
      }).then((res) => {
        this.satdosyafirma = res.Data;
      });

      this.ActionsFilterGet({
        Service: "satdosyaihalekomisyonu",
        Page: this.Page,
        Filter: "&Dosyaid=" + this.satdosyaId + "&Asc=Sira",
      }).then((res) => {
        this.satdosyaihalekomisyonu = res.Data;
      });

      this.ActionsGet({"Service":"SatDosya/"+this.satdosyaId, "Page":this.Page}).then((res) => {
    
        this.Dosya = res.Data;

             this.ActionsGet({"Service":"OkeyValues/"+this.Dosya.Alimturu, "Page":this.Page}).then((res) => {
                  if(res){
                    if (res.Data.Value=="Mal")
                    {this.Alimturu="M";} 
                    else if (res.Data.Value=="Hizmet"){
                        this.Alimturu="H";
                    }
                     

                  }
             });


      });





    },
    ExcelExport(table, name) {
      if (!table.nodeType) table = this.$refs.PiyasaArastirmaTutanagi;
      var ctx = { worksheet: name || "Worksheet", table: table.innerHTML };
      var a = document.createElement('a');
       a.href = this.uri +this.base64(this.format(this.template, ctx));
        a.download = name + '.xls';
        a.click(); 
    },


    BelgeKontrol(FirmaId, BelgeId) {
      var ArrayFilter = this.satdosyazarfacmakontrol.filter((notification) =>
        notification.Dosyafirmaid.includes(FirmaId)
      );
      var Deger = 0;
      let ParseIstenilenbelgeler = JSON.parse(ArrayFilter[0].Istenilenbelgeler);

      for (let Istenilenbelgeler in ParseIstenilenbelgeler) {
        if (Istenilenbelgeler == BelgeId) {
          Deger = ParseIstenilenbelgeler[Istenilenbelgeler];
        }
      }
      if (Deger == 1) {
        return "VAR";
      }
      if (Deger == 2) {
        return "YOK";
      }
      if (Deger == 3) {
        return "UYGUN DEĞİL";
      }
    },

    Export2Word(element, filename ){
    var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
    var postHtml = "</body></html>";
    var html = preHtml+document.getElementById(element).innerHTML+postHtml;

    var blob = new Blob(['\ufeff', html], {
        type: 'application/msword'
    });
    
    // Specify link url
    var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
    
    // Specify file name
    filename = filename?filename+'.doc':'document.doc';
    
    // Create download link element
    var downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);
    
    if(navigator.msSaveOrOpenBlob ){
        navigator.msSaveOrOpenBlob(blob, filename);
    }else{
        // Create a link to the file
        downloadLink.href = url;
        
        // Setting the file name
        downloadLink.download = filename;
        
        //triggering the function
        downloadLink.click();
    }
    
    document.body.removeChild(downloadLink);
   },



  },
};
</script>


<template>
  <Loader>
    <b-modal
      id="zarfacmavebelgekontroltutanagi"
      size="xl"
      scrollable
      :title="$t('zarfacmavebelgekontroltutanagi.Title')"
      title-class="font-18"
      hide-footer
    >
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button
                      type="button"
                      class="btn btn-success btn-rounded mb-2 me-2"
                      @click="
                        ExcelExport(
                          'Zarf Açma ve Belge Kontrol Tutanağı',
                          'Zarf Açma ve Belge Kontrol Tutanağı'
                        )
                      "
                    >
                      <i class="mdi mdi-file-export-outline me-1"></i>
                      {{
                        $t("zarfacmavebelgekontroltutanagi.Page.ExceleAktar")
                      }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-warning btn-rounded mb-2 me-2"
                      @click="Export2Word('exportContent','Zarf Açma ve Belge Kontrol Tutanağı')" 
                    >
                      <i class="mdi mdi-file-export-outline me-1"></i>
                     Word'e Aktar
                    </button>
                  </div>
                </div>
              </div>
              
                <div id="exportContent">
                  <div class="table-responsive" ref="PiyasaArastirmaTutanagi">
                    <table class="table table-borderless mb-0">
                      <thead>
                        <tr>
                          <th style="text-align: center">
                            <b>Zarf Açma ve Belge Kontrol Tutanağı</b>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style="text-align: left">
                             <b>İhale kayıt numarası: </b>  {{ satdosyaihaleilani[0].Ihalekayitnumarasi}}
                          </td>
                        </tr>
                        <tr>
                          <td scope="row" style="text-align: left">
                            <b> İdarenin adı:</b> {{ okurumsabit.Kurumadi}} 
                          </td>
                        </tr>
                        <tr>
                          <td scope="row" style="text-align: left">
                           <b> İşin adı:</b>  {{ satonaybelgesi.Isintanimi}}
                          </td>
                        </tr>
                        <tr>
                          <td scope="row" style="text-align: left">
                            <b>Tutanağın doldurulduğu tarih ve saat : </b>{{ Zarfbelgekontroltutanaktarih | formatDateTime }}  
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <table
                              border="1"
                              class="table table-bordered mb-0"
                              style="border-collapse: collapse; width:100%"
                            >
                              <tbody> 
                                <tr>
                                  <th 
                                    :colspan="
                                      1 +
                                      satdosyaihaleilani[0].Istenilenbelgeler
                                        .length
                                    "
                                    style="text-align: center"
                                  >
                                    ZARF AÇMA VE BELGE KONTROL TUTANAĞI
                                  </th>
                                </tr>
                                <tr>
                                  <th style="border: 1px solid;text-align: right; writing-mode: tb-rl;">
                                   Belge Adı
                                  </th>
                                  <th  style="border: 1px solid; writing-mode: tb-rl;" rowspan="2"
                                    v-for="(
                                      Istenilenbelgeler, index
                                    ) in satdosyaihaleilani[0]
                                      .Istenilenbelgelers"
                                    :key="index"
                                  >
                                    {{ Istenilenbelgeler }}
                                  </th>
                                </tr>
                                 <tr>
                                  <th style="border: 1px solid;">
                                    Adayın/İsteklinin Adı Veya Ticaret Unvanı
                                  </th>
                                 
                                </tr>

                                <tr
                                  v-for="(
                                    satdosyafirmasingle, index
                                  ) in satdosyafirma"
                                  :key="index"
                                >
                                  <td  style="border: 1px solid;">
                                    {{ satdosyafirmasingle.Firmaadi }}
                                  </td>

                                  <td  style="border: 1px solid;"
                                    v-for="(
                                      Istenilenbelgeler, index
                                    ) in satdosyaihaleilani[0]
                                      .Istenilenbelgeler"
                                    :key="index"
                                  >
                                    {{
                                      BelgeKontrol(
                                        satdosyafirmasingle.Id,
                                        Istenilenbelgeler
                                      )
                                    }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <table
                              class="table table-borderless mb-0"
                              style="width:100%; border-collapse: collapse;"
                            >
                              <thead>
                                <tr>
                                  <th
                                    :colspan="satdosyaihalekomisyonu.length"
                                    style="text-align: center;border: 1px solid;"
                                  >
                                    İHALE KOMİSYONU
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td  style="border: 1px solid;"
                                    v-for="(
                                      ihalekomisyonu, index
                                    ) in satdosyaihalekomisyonu"
                                    :key="index"
                                  >  <center>
                                    {{ ihalekomisyonu.Yedekkatildi == false ? ihalekomisyonu.Asilpersonel : ihalekomisyonu.Yedekpersonel  }}
                                 </center> </td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid;"
                                    v-for="(
                                      ihalekomisyonu, index
                                    ) in satdosyaihalekomisyonu"
                                    :key="index"
                                  > <center>
                                    {{ ihalekomisyonu.Yedekkatildi == false ? ihalekomisyonu.Asilunvan : ihalekomisyonu.Yedekunvan  }}
                                 </center> </td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid;"
                                    v-for="(
                                      ihalekomisyonu, index
                                    ) in satdosyaihalekomisyonu"
                                    :key="index"
                                  ><center>
                                    {{ ihalekomisyonu.Gorevi }}
                                  </center></td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid;"
                                    v-for="(
                                      ihalekomisyonu, index
                                    ) in satdosyaihalekomisyonu"
                                    :key="index"
                                  ><center>
                                    İmzası
                                  </center></td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                        </tr>
                        <tr>
                          <td style="text-align: left">
                            Bu tutanak, Şartnamede istenilen belgeler dikkate
                            alınarak düzenlenecek; her bir hücresi için “VAR”
                            veya “YOK” ibarelerinden uygun olanı, teklif mektubu
                            için ise “UYGUN” veya “UYGUN DEĞİL” ibarelerinden
                            birisi kullanılmak suretiyle doldurulacaktır. Bu
                            standart form münferit sözleşme aşamasında da
                            kullanılacaktır. (Münferit sözleşme aşamasında ihale
                            komisyonu üç kişiden oluşturulacaktır.)
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: right">
                            Standart Form ― KİK008.0/{{Alimturu}}
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: right">
                            Zarf Açma ve Belge Kontrol Tutanağı
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </Loader>
</template>
